import { render, staticRenderFns } from "./CitiesTable.vue?vue&type=template&id=0bc9424f&scoped=true&"
import script from "./CitiesTable.vue?vue&type=script&lang=js&"
export * from "./CitiesTable.vue?vue&type=script&lang=js&"
import style0 from "./CitiesTable.vue?vue&type=style&index=0&id=0bc9424f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc9424f",
  null
  
)

export default component.exports